import React from 'react';
import Select, { components } from 'react-select';
import { useField, useFormikContext } from 'formik';
import fruitLogo from '../../../../assets/img/fruitLogo.png';

function SelectSearch({ name, options, placeholder, noOptionsMessage, styles }) {

  const [field, meta, helpers] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (selectedOption) => {
    setFieldValue(name, selectedOption ? selectedOption.value : '');
  };

  const selectedValue = options.find(option => option.value === field.value) || null;


  const CustomDropdownIndicator = (props) => {
    const hasValue = props.selectProps.value;
    if (hasValue) return null; // 👈 oculta a seta se houver valor
    return (
      // <components.DropdownIndicator {...props}>
      //   <img
      //     src={fruitLogo}
      //     alt="icone"
      //     style={{
      //       width: '16px',
      //       height: '16px',
      //     }}
      //   />
      // </components.DropdownIndicator>
      <components.DropdownIndicator {...props}>
        <svg
          height="20"
          width="20"
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
          style={{ display: 'block', fill: '#8bc540' }} // cor e estilo
        >
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </components.DropdownIndicator>

    );
  };

  const CustomClearIndicator = (props) => {
    return (
      <components.ClearIndicator {...props}>
        <svg
          width="14"
          height="14"
          viewBox="0 0 20 20"
          fill="#8bc540"
        >
          <path d="M14.348 5.652a.5.5 0 0 0-.707 0L10 9.293 6.36 5.652a.5.5 0 1 0-.707.707L9.293 10l-3.64 3.64a.5.5 0 1 0 .707.707L10 10.707l3.64 3.64a.5.5 0 0 0 .707-.707L10.707 10l3.64-3.64a.5.5 0 0 0 0-.707z" />
        </svg>
      </components.ClearIndicator>
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: '20px',
      minHeight: '20px',
      width: '300px',
      borderRadius: '99px',
      borderColor: '#8bc540',
      boxShadow: state.isFocused ? '0 0 0 0.2px #8bc540' : 'none',
      '&:hover': {
        borderColor: '#8bc540',
      },
      fontSize: '0.8rem',
      fontWeight: 'lighter',
      padding: '0 2px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '20px',
      padding: '0 6px',
      margin: '-5px 0px 0px 0px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '20px',
      color: 'red',
      fontSize: '3px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      width: 'none', // Espessura da barra divisora
      backgroundColor: '#8bc540',
      margin: '0 4px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '0px 4px 0px 4px',
      color: '#8bc540',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '20px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#8bc540' : 'white',
      color: state.isFocused ? 'white' : 'black',
      fontSize: '0.8rem',
      cursor: 'pointer',
    }),
    noOptionsMessage: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#8bc540' : 'white',
      color: state.isFocused ? 'white' : 'black',
      fontSize: '0.8rem',
      cursor: 'pointer',
    }),
    menu: (provided) => ({
      ...provided,
      width: '300px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '150px', // ou outro limite, se necessário
      overflowY: 'auto',
      scrollbarWidth: 'thin', // Firefox
      scrollbarColor: '#8bc540 transparent', // Firefox
    }),

  };

  return (
    <div>
      <Select
        name={name}
        value={selectedValue}
        options={options}
        placeholder={placeholder || 'Selecione ou digite uma opção'}
        styles={customStyles}
        noOptionsMessage={() => 'Nenhuma opção disponível'}
        // isSearchable={false}
        isClearable={true}
        components={{
          DropdownIndicator: CustomDropdownIndicator,
          ClearIndicator: CustomClearIndicator

        }}
        onChange={handleChange}
      />
      {meta.touched && meta.error && (
        <div className="error-message">{meta.error}</div>
      )}
    </div>
  )
}

export default SelectSearch